"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * WindowItemBaselineConverter.
 *
 * @author Stepan Mik
 */


var WindowItemPostBaselineConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(WindowItemPostBaselineConverter, _DataObjectConverter_);

  function WindowItemPostBaselineConverter() {
    _classCallCheck(this, WindowItemPostBaselineConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowItemPostBaselineConverter).apply(this, arguments));
  }

  return WindowItemPostBaselineConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.WindowItemPostBaselineConverter = WindowItemPostBaselineConverter;